import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackLead } from '../utils/metaPixel';
/**
 * Listens to client-side route changes and fires Meta Pixel events:
 * - PageView on every route load (including the first render)
 * - Lead when the /thank_you confirmation page loads
 *
 * Renders nothing. Must live inside the Router so useLocation works.
 */
export function PixelTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
    if (location.pathname === '/thank_you') {
      trackLead();
    }
  }, [location.pathname]);
  return null;
}